// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TBiometricDataUpdateReq, TProfileUpdateReq } from '../types/requests';

export function ProfileController() {
  const getProfileInfo = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/managed-user/info`, {
      headers: getAuthHeaders(),
    });
  };

  const updateProfileInfo = async <T>(data: TProfileUpdateReq): Promise<T> => {
    return await axios.put(`${DEV_APP_API_URL}/user/update`, data, {
      headers: getAuthHeaders(),
    });
  };

  const getShooterProfileInfo = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/user/info`, {
      headers: getAuthHeaders(),
    });
  };

  const getBiometricData = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/bio-data/`, {
      headers: getAuthHeaders(),
    });
  };

  const updateBiometricData = async <T>(data: TBiometricDataUpdateReq): Promise<T> => {
    return await axios.put(`${DEV_APP_API_URL}/bio-data/`, data, {
      headers: getAuthHeaders(),
    });
  };

  return { getProfileInfo, getShooterProfileInfo, updateProfileInfo, getBiometricData, updateBiometricData };
}
